class SubscriptionBuilderProgressBar extends HTMLElement {
  constructor() {
    super();
    this.bundleSize = 0;
    this.discountActive = false;

    this._clubMembershipToggle = false;

    // Bind methods
 //   this.render = this.render.bind(this);
   // this.getTickValues = this.getTickValues.bind(this);
   // this.calculateProgressPercentage = this.calculateProgressPercentage.bind(this);
  }

  set clubMembershipToggle(value) {
    this._clubMembershipToggle = value;
    this.render();
    //console.log(`Club membership toggle set to: ${value}`);
    //this.renderTickMarks();
  }

  get clubMembershipToggle() {
    return this._clubMembershipToggle;
  }


  // Only observe 'bundle-size' since 'discount-active' does not change after initialization
  static get observedAttributes() {
    return ['bundle-size', 'discount-active'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'bundle-size') {
      this.bundleSize = parseInt(newValue, 10) || 0;
      //console.log(`Bundle size changed from ${oldValue} to ${newValue}`);
      this.render();
    }
    if (name === 'discount-active') {
      this.discountActive = newValue === 'true';
      //console.log(`Discount active changed from ${oldValue} to ${newValue}`);
      //this.renderTickMarks();
    }
  }

  connectedCallback() {
    this.bundleSize = parseInt(this.getAttribute('bundle-size')) || 0;
    this.discountActive = this.getAttribute('discount-active') === 'true';

    // Select elements within the component
    //.subscription-progress-bar
    this.progressBar = this.querySelector('.subscription-progress-bar');
    this.progressBarBg = this.querySelector('.subscription-progress-bar');
    this.progressFill = this.querySelector('.subscription-progress-fill');
    this.ticksContainer = this.querySelector('.subscription-progress-ticks-container');

    this.renderTickMarks();
    this.render();
  }

  render() {
    if (!this.progressFill) return;
  
    // Query necessary elements.
    
    const progressBarBg = this.querySelector('.subscription-progress-bar-bg');
    const subProgressTicks = this.querySelector('.subscription_progress_ticks');
    const clubProgressTicks = this.querySelector('.club_progress_ticks');
    // Toggle tick displays and update background class based on club membership.
    if (this._clubMembershipToggle) {
      subProgressTicks && (subProgressTicks.style.display = 'none');
      clubProgressTicks && (clubProgressTicks.style.display = 'grid');
      progressBarBg && progressBarBg.classList.add('club_progress_bar');
    } else {
      clubProgressTicks && (clubProgressTicks.style.display = 'none');
      subProgressTicks && (subProgressTicks.style.display = 'grid');
      progressBarBg && progressBarBg.classList.remove('club_progress_bar');
    }
  
    // Hide progress fill if bundleSize is 0 or less.
    if (this.bundleSize <= 0) {
      this.progressFill.style.display = 'none';
      return;
    }
    this.progressFill.style.display = 'block';
  
    // Determine grid span and background color threshold.
    let spanValue, bgThreshold;
    if (this._clubMembershipToggle) {
      // For club members: span equals bundleSize if 3 or less; otherwise, span 6.
      spanValue = this.bundleSize <= 3 ? this.bundleSize : 6;
      bgThreshold = 4;
    } else {
      // For non-club: span equals bundleSize if 3 or less; for 4, span 6; for 5 or more, span 9.
      spanValue = this.bundleSize <= 3 ? this.bundleSize : (this.bundleSize === 4 ? 6 : 9);
      bgThreshold = 5;
    }
  
    // Set grid column span.
    this.progressFill.style.gridColumnEnd = `span ${spanValue}`;
  
    // Update the progress bar background color if defined.
    if (this.progressBar) {
      this.progressBar.style.backgroundColor = this.bundleSize > bgThreshold ? '#41C3D6' : '#EFEFEF';
    }
  }
  
  renderTickMarks() {
    if (!this.ticksContainer) return;

    this.ticksContainer.innerHTML = '';

    const tickValues = this.getTickValues();

    // Create ticks
    tickValues.forEach((tick) => {
      const tickElement = document.createElement('div');
      tickElement.className = 'sb-tick';
      tickElement.style.left = this.calculateTickPosition(tick.value) + '%';

      // Tick marker
      const tickMarker = document.createElement('div');
      tickMarker.className = 'sb-tick-marker';

      // Tick label
      const tickLabel = document.createElement('div');
      tickLabel.className = 'sb-tick-label';

      // Label content
      const labelText = document.createElement('h5');
      labelText.className = 'sb-tick-label-text h6';
      labelText.textContent = tick.label;
      tickLabel.appendChild(labelText);

      if (this.discountActive && tick.discount) {
        const discountText = document.createElement('h5');
        discountText.className = 'sb-tick-discount-text';
        discountText.textContent = tick.discount;
        tickLabel.appendChild(discountText);
      }

      const valueText = document.createElement('p');
      valueText.className = 'sb-tick-value-text p14';
      valueText.textContent = `(${tick.value}) 6-Packs`;
      tickLabel.appendChild(valueText);

      // Assemble tick
      tickElement.appendChild(tickMarker);
      tickElement.appendChild(tickLabel);
      this.ticksContainer.appendChild(tickElement);
    });
  }

  getTickValues() {
    if (this.discountActive) {
      return [
        { value: 3, discount: '50% off 1st mo.', label: 'Save 5%' },
        { value: 4, discount: '50% off 1st mo.', label: 'Save 10%' },
        { value: 5, discount: '50% off 1st mo.', label: 'Save 15%' },
      ];
    }
    if (this._clubMembershipToggle) {
      return [
        { value: 3, label: 'Save 5%' },
        { value: 4, label: 'Member Price' },
      ];
    }
    return [
      { value: 3, label: 'Save 5%' },
      { value: 4, label: 'Save 10%' },
      { value: 5, label: 'Save 15%' },
    ];
  }

  calculateProgressPercentage() {
    const maxBundleSize = 5.9;
    const percentage = Math.min((this.bundleSize / maxBundleSize) * 100, 100);
    return percentage;
  }

  calculateTickPosition(value) {
    const maxBundleSize = 5.9;
    const percentage = (value / maxBundleSize) * 100;
    return percentage;
  }
}

customElements.define('subscription-builder-progress-bar', SubscriptionBuilderProgressBar);
